import React from "react";
import { Route, Routes } from "react-router-dom";
import { IntlProvider } from "react-intl";
import Login from "../views/Pages/Login";
import Home from "../views/Pages/Home";
import { PrivateRoute } from "./PrivateRoute";
import Teste from "../views/Pages/teste";

const RoutesApp = () => {
  return (
    <IntlProvider locale="pt-BR">
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route path="/teste" element={<Teste />} />
      </Routes>
    </IntlProvider>
  );
};

export default RoutesApp;
